import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import Divider from "@mui/material/Divider";
import DeleteIcon from "@mui/icons-material/Delete";
import PropTypes from "prop-types";
import { deleteSaleProductQuarter } from "rest/requests";
import swal from "sweetalert";

const ITEM_HEIGHT = 48;

export default function SalesActionMenu({ setEditing, element, setElementToEdit, setDeleting }) {
  const rowElement = element;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const deleteSale = () => {
    setDeleting(false);
    swal({
      title: "Confirmación antes de eliminar",
      text: "Una vez eliminado el registro no se podra recuperar",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteSaleProductQuarter(element.id, element)
          .then((req, res) => {
            console.log("Success..", res);
            setDeleting(true);
            swal("El registro ha sido eliminado exitosamente", {
              icon: "success",
            });
          })
          .catch((error) => {
            console.log("Error...", error);
            swal("Oops!", "Algo a salido mal durante el procesamiento", "error");
          });
      } else {
        swal("El proceso de eliminacion a sido detenido. Su registro esta a salvo!");
      }
    });
    setAnchorEl(null);
  };

  const edit = () => {
    setAnchorEl(null);
    if (setEditing !== null) {
      setEditing(true);
      setElementToEdit(rowElement);
    }
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: "20ch",
          },
        }}
      >
        <MenuItem key="Editar" onClick={edit}>
          <EditIcon color="success" />
          &nbsp;Editar
        </MenuItem>
        <Divider />
        <MenuItem key="Eliminar" onClick={deleteSale}>
          <DeleteIcon color="primary" />
          &nbsp;Eliminar
        </MenuItem>
        <Divider />
      </Menu>
    </div>
  );
}

SalesActionMenu.defaultProps = {
  setEditing: null,
  element: {},
  setElementToEdit: null,
  setDeleting: null,
};

SalesActionMenu.propTypes = {
  setEditing: PropTypes.any,
  element: PropTypes.object,
  setElementToEdit: PropTypes.func,
  setDeleting: PropTypes.func,
};
